import React from "react";
import PropTypes from "prop-types";
import { Table, useMediaQuery } from "discover.medical.react-component-library";
import FollowItem from "../FollowItem";

const FollowedContentTable = ({
  followedFeeds,
  deleteIcon,
  isDeleting,
  onDelete,
  onClose,
}) => {
  const isMobile = useMediaQuery("max", "sm");

  return (
    <Table>
      <Table.Body>
        {followedFeeds.map((feed) => (
          <FollowItem
            key={feed.id}
            followId={feed.id}
            followType={feed.type}
            prettyPubType={feed.prettyPubType}
            title={feed.title}
            isTitleHighlighted={feed.isTitleHighlighted}
            slug={feed.slug}
            onDelete={() => onDelete(feed.type, feed.id)}
            onClick={onClose}
            deleteIcon={deleteIcon}
            isDeleteEnabled={isDeleting}
            isMobile={isMobile}
          />
        ))}
      </Table.Body>
    </Table>
  );
};

FollowedContentTable.propTypes = {
  followedFeeds: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      prettyPubType: PropTypes.string.isRequired,
      isTitleHighlighted: PropTypes.bool,
    })
  ).isRequired,
  deleteIcon: PropTypes.shape({
    glyph: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
  }).isRequired,
  isDeleting: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

FollowedContentTable.displayName = "FollowedContentTable";
export default FollowedContentTable;
